import React, { useState } from 'react';
// Components
import CambiarPass from './CambiarPass';
import EditContacto from './EditContacto';
// Material-UI
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/core/styles';
// Icons
import { User, Edit } from 'tabler-icons-react';
// Context
import { CuentaProvider, useCuenta } from './CuentaContext';
// Styles
import '../../styles/cuenta.css';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Cuenta() {
    const { theUser, roles, openSnack, setOpenSnack, snackMsg } = useCuenta();
    const [passOpen, setPassOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;

    return (
        <div className="cuenta-page">
            <div className="cuenta-header">
                <h1 className="titulo">Mi cuenta</h1>
                <p className="desc">Visualiza o modifica la información sobre tu perfil.</p>
            </div>

            {/* ── Profile card (Facebook-style, foto futura aquí) ── */}
            <Paper className="cuenta-profile-card" elevation={1}>
                <div className="cuenta-banner" style={{ background: `linear-gradient(135deg, ${primaryColor} 0%, ${theme.palette.secondary.main} 100%)` }} />
                <Avatar className="cuenta-avatar" style={{ backgroundColor: primaryColor }}>
                    <User size={40} strokeWidth={1.5} />
                </Avatar>
                <div className="cuenta-profile-info">
                    <p className="cuenta-profile-name">{theUser.nombre} {theUser.apellido}</p>
                    <p className="cuenta-profile-username">@{theUser.usuario}</p>
                </div>
            </Paper>

            {/* ── Cards ── */}
            <div className="cuenta-body">

                {/* Información Personal */}
                <div className="cuenta-card">
                    <div className="cuenta-card-header">
                        <h2 className="cuenta-card-title">Información personal</h2>
                    </div>
                    <div className="cuenta-card-body">
                        <div className="cuenta-form-grid">
                            <TextField label="Nombre de usuario" value={theUser.usuario || ''} fullWidth InputProps={{ readOnly: true }} />
                            <TextField label="Contraseña" type="password" value="••••••••" fullWidth InputProps={{ readOnly: true }} />
                            <TextField label="Nombre" value={theUser.nombre || ''} fullWidth InputProps={{ readOnly: true }} />
                            <TextField label="Apellidos" value={theUser.apellido || ''} fullWidth InputProps={{ readOnly: true }} />
                        </div>
                    </div>
                </div>

                {/* Información Laboral */}
                <div className="cuenta-card">
                    <div className="cuenta-card-header">
                        <h2 className="cuenta-card-title">Información laboral</h2>
                    </div>
                    <div className="cuenta-card-body">
                        <p className="cuenta-section-subtitle">Roles del usuario</p>
                        <div className="cuenta-roles-chips">
                            {roles.map(r => (
                                <Chip
                                    key={r.nombre}
                                    label={r.nombre}
                                    color="primary"
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Información de Contacto */}
                <div className="cuenta-card cuenta-card--full">
                    <div className="cuenta-card-header">
                        <h2 className="cuenta-card-title">Información de contacto</h2>
                        <Button variant="text" className="usuarios-toolbar-btn" onClick={() => setEditOpen(true)}>
                            <Edit size={16} strokeWidth={2} /> Editar
                        </Button>
                    </div>
                    <div className="cuenta-card-body">
                        <div className="cuenta-form-grid">
                            <div>
                                <label className="cuenta-field-label">Teléfono</label>
                                <p className="cuenta-field-value">{theUser.phoneNumber || '—'}</p>
                            </div>
                            <div>
                                <label className="cuenta-field-label">Correo electrónico</label>
                                <p className="cuenta-field-value">{theUser.email || '—'}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Seguridad */}
                <div className="cuenta-card cuenta-card--full">
                    <div className="cuenta-card-header">
                        <h2 className="cuenta-card-title">Seguridad</h2>
                    </div>
                    <div className="cuenta-card-body">
                        <div className="cuenta-security-row">
                            <div>
                                <p className="cuenta-field-label">Contraseña</p>
                                <p className="cuenta-field-value">••••••••</p>
                            </div>
                            <Button variant="outlined" color="secondary" className="cuenta-change-pass-btn" onClick={() => setPassOpen(true)}>
                                Cambiar contraseña
                            </Button>
                        </div>
                    </div>
                </div>

            </div>

            <CambiarPass open={passOpen} onClose={() => setPassOpen(false)} />
            <EditContacto open={editOpen} onClose={() => setEditOpen(false)} />

            <Snackbar open={openSnack} autoHideDuration={3000} onClose={() => setOpenSnack(false)}>
                <Alert onClose={() => setOpenSnack(false)} severity="success">{snackMsg}</Alert>
            </Snackbar>
        </div>
    );
}

const CuentaWrapper = () => (
    <CuentaProvider>
        <Cuenta />
    </CuentaProvider>
);

export default CuentaWrapper;
